
import { defineComponent, ref } from 'vue';
import RadioGroup from './components/RadioGroup.vue';

export default defineComponent({
  name: 'App',
  components: {
    RadioGroup,
  },
  setup() {
    const frameworks = ref([
      { label: 'Vue', value: 'vue' },
      { label: 'React', value: 'react' },
      { label: 'Angular', value: 'angular' },
      { label: 'Svelte', value: 'svelte' },
    ]);

    const framework = ref('vue');

    return { frameworks, framework };
  },
});
